<script setup>
defineProps({
  disableNavigation: {
    type: Boolean,
    default: false,
  },
  targetPath: {
    type: String,
    default: "/",
  },
})
</script>

<template>
  <v-card class="mb-4">
    <v-card-title
      class="text-capitalize text-headline-small d-flex align-center"
      :class="{'ma-2': disableNavigation}"
    >
      <v-btn
        v-if="!disableNavigation"
        icon
        color="secondary"
        variant="plain"
        :to="targetPath"
        aria-label="back to overview"
      >
        <v-icon>$mdiChevronLeft</v-icon>
      </v-btn>
      <v-icon
        color="secondary"
        size="x-small"
        class="mr-1"
      >
        <slot name="icon" />
      </v-icon>
      <slot />
    </v-card-title>
  </v-card>
</template>
